module.exports = __webpack_public_path__ + "static/media/toggler.872ddb9d.svg";